module.exports = __webpack_public_path__ + "static/media/signInIcon-m.88c38616.svg";